/**
 * Stripe.js, loaded once for the whole page.
 *
 * A bank asking the cardholder to approve a payment is answered with Stripe.js,
 * whether or not a card form is on screen, so the loader cannot belong to the
 * form.
 */
let loading = null

export function loadStripe(publishableKey) {
  loading ??= new Promise((resolve, reject) => {
    if (window.Stripe) {
      resolve()

      return
    }

    const script = document.createElement('script')
    script.src = 'https://js.stripe.com/v3/'
    script.async = true
    script.onload = resolve
    script.onerror = error => {
      loading = null
      reject(error)
    }
    document.head.appendChild(script)
  })

  return loading.then(() => window.Stripe(publishableKey))
}
